import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Breadcrumbs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/blog-detail/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ButtonBack/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DangerouslySetInnerHTML/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Icons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NextLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/blog/detail/index.tsx");
